import {style} from '@vanilla-extract/css'

export const tooltipLayer = style({
  pointerEvents: 'none',
})

export const tooltipCard = style({
  willChange: 'transform',
})
